import { cacheData, getCachedData } from './offlineCache';

// Who was signed in last, kept so the app can open in offline mode at a venue with no signal.
// Never holds the session token (that stays in the browser's cookie): just enough to know whose
// cached gig data this is and what their role lets them see. Sign-out clears it with the rest of
// the offline cache.
export const saveLastSession = ({ userId, name, artistId, bandRole, subscriptionTier }) =>
  cacheData('lastSession', { userId, name, artistId, bandRole, subscriptionTier });

export const getLastSession = async () => (await getCachedData('lastSession'))?.data || null;
